<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@/utils/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
  columnId?: string
}>()
</script>

<template>
  <td
    data-slot="table-cell"
    :data-column-id="props.columnId"
    :class="
      cn(
        'px-2 py-2.5 align-middle whitespace-nowrap [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px] overflow-hidden',
        props.class,
      )
    "
  >
    <slot />
  </td>
</template>
